import React, { Fragment} from 'react';

export default () => {
    
    const countyList = [
        {
            option:"Arkansas",
            value: "Arkansas"
        },
        {
            option:"Ashley",
            value: "Ashley"
        },
        {
            option:"Baxter",
            value: "Baxter"
        },
        {
            option:"Benton",
            value: "Benton"
        },
        {
            option:"Boone",
            value: "Boone"
        },
        {
            option:"Bradley",
            value: "Bradley"
        },
        {
            option:"Calhoun",
            value: "Calhoun"
        },
        {
            option:"Carroll",
            value: "Carroll"
        },
        {
            option:"Chicot",
            value: "Chicot"
        },
        {
            option:"Clark",
            value: "Clark"
        },
        {
            option:"Clay",
            value: "Clay"
        },
        {
            option:"Cleburne",
            value: "Cleburne"
        },
        {
            option:"Cleveland",
            value: "Cleveland"
        },
        {
            option:"Columbia",
            value: "Columbia"
        },
        {
            option:"Conway",
            value: "Conway"
        },
        {
            option:"Craighead",
            value: "Craighead"
        },
        {
            option:"Crawford",
            value: "Crawford"
        },
        {
            option:"Crittenden",
            value: "Crittenden"
        },
        {
            option:"Cross",
            value: "Cross"
        },
        {
            option:"Dallas",
            value: "Dallas"
        },
        {
            option:"Desha",
            value: "Desha"
        },
        {
            option:"Drew",
            value: "Drew"
        },
        {
            option:"Faulkner",
            value: "Faulkner"
        },
        {
            option:"Franklin",
            value: "Franklin"
        },
        {
            option:"Fulton",
            value: "Fulton"
        },
        {
            option:"Garland",
            value: "Garland"
        },
        {
            option:"Grant",
            value: "Grant"
        },
        {
            option:"Greene",
            value: "Greene"
        },
        {
            option:"Hempstead",
            value: "Hempstead"
        },
        {
            option:"Hot Spring",
            value: "Hot Spring"
        },
        {
            option:"Howard",
            value: "Howard"
        },
        {
            option:"Independence",
            value: "Independence"
        },
        {
            option:"Izard",
            value: "Izard"
        },
        {
            option:"Jackson",
            value: "Jackson"
        },
        {
            option:"Jefferson",
            value: "Jefferson"
        },
        {
            option:"Johnson",
            value: "Johnson"
        },
        {
            option:"Lafayette",
            value: "Lafayette"
        },
        {
            option:"Lawrence",
            value: "Lawrence"
        },
        {
            option:"Lee",
            value: "Lee"
        },
        {
            option:"Lincoln",
            value: "Lincoln"
        },
        {
            option:"Little River",
            value: "Little River"
        },
        {
            option:"Logan",
            value: "Logan"
        },
        {
            option:"Lonoke",
            value: "Lonoke"
        },
        {
            option:"Madison",
            value: "Madison"
        },
        {
            option:"Marion",
            value: "Marion"
        },
        {
            option:"Miller",
            value: "Miller"
        },
        {
            option:"Mississippi",
            value: "Mississippi"
        },
        {
            option:"Monroe",
            value: "Monroe"
        },
        {
            option:"Montgomery",
            value: "Montgomery"
        },
        {
            option:"Nevada",
            value: "Nevada"
        },
        {
            option:"Newton",
            value: "Newton"
        },
        {
            option:"Ouachita",
            value: "Ouachita"
        },
        {
            option:"Perry",
            value: "Perry"
        },
        {
            option:"Phillips",
            value: "Phillips"
        },
        {
            option:"Pike",
            value: "Pike"
        },
        {
            option:"Poinsett",
            value: "Poinsett"
        },
        {
            option:"Polk",
            value: "Polk"
        },
        {
            option:"Pope",
            value: "Pope"
        },
        {
            option:"Prairie",
            value: "Prairie"
        },
        {
            option:"Pulaski",
            value: "Pulaski"
        },
        {
            option:"Randolph",
            value: "Randolph"
        },
        {
            option:"Saline",
            value: "Saline"
        },
        {
            option:"Scott",
            value: "Scott"
        },
        {
            option:"Searcy",
            value: "Searcy"
        },
        {
            option:"Sebastian",
            value: "Sebastian"
        },
        {
            option:"Sevier",
            value: "Sevier"
        },
        {
            option:"Sharp",
            value: "Sharp"
        },
        {
            option:"St. Francis",
            value: "St. Francis"
        },
        {
            option:"Stone",
            value: "Stone"
        },
        {
            option:"Union",
            value: "Union"
        },
        {
            option:"Van Buren",
            value: "Van Buren"
        },
        {
            option:"Washington",
            value: "Washington"
        },
        {
            option:"White",
            value: "White"
        },
        {
            option:"Woodruff",
            value: "Woodruff"
        },
        {
            option:"Yell",
            value: "Yell"
        },
    ]

    return (
        <Fragment>
                 <option />
                {
                    countyList.map((l, i) =>(
                    <option key={i} value={l.value}>{l.option}</option>
                    ))
                }     
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/wizardSection/renderCountiesOptions.jsx